module.exports = __webpack_public_path__ + "img/left_yezi.aa7c0061.svg";